import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import "./styles/index.css";

const container = document.getElementById("root");
if (!container) throw new Error("Élément #root introuvable");

// Le filet est AU-DESSUS du routeur : une exception dans n'importe quel écran est
// attrapée, y compris pendant la première résolution de route. En dessous, une page
// qui casse au montage laisserait encore l'écran blanc qu'on cherche à éviter.
createRoot(container).render(
	<StrictMode>
		<ErrorBoundary>
			<App />
		</ErrorBoundary>
	</StrictMode>,
);
